import {httpGet,httpPut,httpDelete,httpPost,httpPostForm,httpDownload} from '@/util/request.js';
import appConfig from '@/config';

export default class BudgetCostReachApi{

  static QUERY_BUDGET_REACH_LIST = appConfig.gatewayUrl+appConfig.pdServicePath+"/wb/pd-wb-budget-cost-reach/list";
  static QUERY_BUDGET_REACH_LIST_QUARTER = appConfig.gatewayUrl+appConfig.pdServicePath+"/wb/pd-wb-budget-cost-reach/list/quarter";
  static BUDGET_REACH_DETAIL = appConfig.gatewayUrl+appConfig.pdServicePath+"/wb/pd-wb-budget-cost-reach/detail";
  static BUDGET_REACH_EXPORT_DATA = appConfig.gatewayUrl+appConfig.pdServicePath+"/wb/pd-wb-budget-cost-reach/exportData";
  static BUDGET_REACH_EXPORT_DATA_QUARTER = appConfig.gatewayUrl+appConfig.pdServicePath+"/wb/pd-wb-budget-cost-reach/exportData/quarter";

    static list(params){
		  return httpGet(BudgetCostReachApi.QUERY_BUDGET_REACH_LIST,params);
    }

    static listQuarter(params){
		  return httpGet(BudgetCostReachApi.QUERY_BUDGET_REACH_LIST_QUARTER,params);
    }

    static detail(params){
		  return httpGet(BudgetCostReachApi.BUDGET_REACH_DETAIL,params);
    }

    static exportData(params){
		return httpDownload(BudgetCostReachApi.BUDGET_REACH_EXPORT_DATA,params);
    }

    static exportDataQuarter(params){
		return httpDownload(BudgetCostReachApi.BUDGET_REACH_EXPORT_DATA_QUARTER,params);
    }

}